import IssueDetails from "./performance/PerformanceDetails";
import SEOIssueDetails from "./seo/SEODetails";
import BestPracticeIssueDetails from "./best-practice/BestPracticeDetails";
import AccessibilityIssueDetails from "./accessibility/AccessibilityDetails";
import AgenticBrowsingDetails from "./agentic/AgenticBrowsingDetails";

const hasCategory = (knownIssues, category) =>
  Object.values(knownIssues).some((issue) => issue.category === category);

const AllIssueDetails = ({
  knownIssues,
  screenshot,
  url,
  strategy,
  agenticBrowsing,
}) => {
  // Check if there are any issues at all
  const hasAnyIssues = Object.values(knownIssues).length > 0;

  return (
    <div className="space-y-10">
      {!hasAnyIssues && !agenticBrowsing?.totalCount && (
        <div className="mt-6 p-4 bg-green-100 border border-green-200 rounded-lg">
          <p className="text-green-800 font-semibold">
            No major issues detected. Great job!
          </p>
        </div>
      )}
      {hasCategory(knownIssues, "performance") && (
        <section>
          <h2 className="text-xl font-bold mb-2">Performance</h2>
          <IssueDetails
            knownIssues={knownIssues}
            screenshot={screenshot}
            url={url}
          />
        </section>
      )}
      {hasCategory(knownIssues, "accessibility") && (
        <section>
          <h2 className="text-xl font-bold mb-2">Accessibility</h2>
          <AccessibilityIssueDetails
            knownIssues={knownIssues}
            screenshot={screenshot}
            strategy={strategy}
          />
        </section>
      )}
      {hasCategory(knownIssues, "best-practices") && (
        <section>
          <h2 className="text-xl font-bold mb-2">Best Practices</h2>
          <BestPracticeIssueDetails
            knownIssues={knownIssues}
            screenshot={screenshot}
          />
        </section>
      )}
      {hasCategory(knownIssues, "seo") && (
        <section>
          <h2 className="text-xl font-bold mb-2">SEO</h2>
          <SEOIssueDetails
            knownIssues={knownIssues}
            screenshot={screenshot}
          />
        </section>
      )}
      {agenticBrowsing?.totalCount > 0 && (
        <AgenticBrowsingDetails
          agenticBrowsing={agenticBrowsing}
          knownIssues={knownIssues}
        />
      )}
    </div>
  );
};

export default AllIssueDetails;
